import React, { useEffect, useRef, useState } from "react";
import { usePermissions } from "../../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import * as func from "../../../common/manipurCommon/FunctionCalls";
import * as api from "../../../common/manipurCommon/API";
import Utils from "../../../common/manipurCommon/Utils";
import ImageWithBasePath from "../../../../core/data/img/ImageWithBasePath";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Select from "react-select";
import { Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, Button } from "react-bootstrap";
import Swal from "sweetalert2";

const CenterBatchAthlete = () => {

    const [batchList, setBatchList] = useState<any[]>([]);
    const [athleteList, setAthleteList] = useState<any[]>([]);
    const [batchAthleteList, setBatchAthleteList] = useState<any[]>([]);
    const [stateList, setStateList] = useState<any[]>([]);
    const [districtList, setDistrictList] = useState<any[]>([]);
    const [cityList, setCityList] = useState<any[]>([]);
    const [centerList, setCenterList] = useState<any[]>([]);
    const [batchAthleteName, setBatchAthleteName] = useState("");
    const [stateId, setStateId] = useState("");
    const [districtId, setDistrictId] = useState("");
    const [cityId, setCityId] = useState("");
    const [centerId, setCenterId] = useState("");
    const [batchId, setBatchId] = useState("");
    const [athleteId, setAthleteId] = useState("");
    const [batchAthleteStatus, setBatchAthleteStatus] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [showAthltLst, setShowAthltLst] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);
    const addcheckboxRefs = useRef([]);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    useEffect(() => {
        fetchBatchAthletes();
    }, [])

    async function fetchBatchAthletes() {
        setIsLoading(true);
        const batchAthleteResponse = await func.centerBatchAthelete(null);
        setBatchAthleteList(Array.isArray(batchAthleteResponse) ? batchAthleteResponse : [])
        setIsLoading(false);
    }

    const filteredData = batchAthleteList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const batchNameRender = (rowData) => {
        return <span>{rowData.centerBatchName}</span>;
    };

    const athleteNameRender = (rowData) => {
        return <span>{rowData.athleteName}</span>;
    };

    const batchAthleteStatusRender = (rowData) => {
        return <span>{(rowData.centerBatchAthleteStatus == 1) ? "Active" : "Inactive"}</span>;

    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editBatchAthlete(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const btchAthleteId = rowData.centerBatchAthleteId;
        return (
            <Link to="#" onClick={() => deleteBatchAthlete(btchAthleteId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function newBatchAthlete() {
        setIsEdit(false)
        setOpenModal(true)
        // const stateResponse = await func.listGeoStates();
        // setStateList(Array.isArray(stateResponse) ? stateResponse : [])
        const batchResponse = await func.centerBatch(null);
        setBatchList(Array.isArray(batchResponse) ? batchResponse : [])
        const centerResponse = await func.listGeoCenters();
        setCenterList(Array.isArray(centerResponse) ? centerResponse : [])
        setCenterId('')
        setBatchId('')
        setAthleteId('')
        setAthleteList([])
        setShowAthltLst(false)
    }

    async function editBatchAthlete(rowData: { centerBatchAthleteId: string | number; }) {
        const btchAthleteId = rowData.centerBatchAthleteId;
        setIsEdit(true)
        setOpenModal(true)
        setShowAthltLst(true)
        const stateResponse = await func.listGeoStates();
        setStateList(Array.isArray(stateResponse) ? stateResponse : [])
        const batchResponse = await func.centerBatch(null);
        setBatchList(Array.isArray(batchResponse) ? batchResponse : [])
        const centerResponse = await func.listGeoCenters();
        setCenterList(Array.isArray(centerResponse) ? centerResponse : [])
        const getDetails = await func.centerBatchAthelete(btchAthleteId);
        const athltResponse = await func.listCenterActiveAthletes(getDetails.centerId);
        setAthleteList(Array.isArray(athltResponse) ? athltResponse : [])
        setCenterId(getDetails.centerId);
        setBatchId(getDetails.centerBatchId);
        setAthleteId(getDetails.centerBatchAthleteId);
        setBatchAthleteName(getDetails.athleteName);
        setBatchAthleteStatus(getDetails.centerBatchAthleteStatus);
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateBatchAthlete();
            } else {
                const selectedathletes = addcheckboxRefs.current
                    .filter(checkbox => checkbox.checked)
                    .map(checkbox => Number(checkbox.value));

                if (batchId && selectedathletes) {
                    const formData = new FormData();
                    formData.append("batchId", batchId);
                    formData.append("athlete", JSON.stringify(selectedathletes));

                    const createBatchAthlete = api.CenterBatchAthlete;
                    fetch(createBatchAthlete, {
                        method: "POST",
                        headers: {
                            "Authorization": 'Bearer ' + Utils.getAccessToken()
                        },
                        body: formData
                    })
                        .then((response) => response.json())
                        .then((result) => {
                            if (result.error == false) {
                                Swal.fire({
                                    title: 'Success',
                                    text: result.message,
                                    icon: 'success',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        // window.location.reload(); // 🔁 Reload only after OK is clicked
                                        setOpenModal(false);
                                        fetchBatchAthletes();
                                    }
                                });
                            } else {
                                if (result.code == 401) {
                                    Utils.logoutUser();
                                }
                                Swal.fire({
                                    title: 'Error',
                                    text: result.message,
                                    icon: 'error',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                })
                            }
                        })
                }
            }
        }
    }

    function updateBatchAthlete() {
        const formData = new FormData();
        formData.append("batch", batchId);
        formData.append("athlete", athleteId);
        formData.append("status", batchAthleteStatus);

        const updatebtchathlete = api.CenterBatchAthlete + '/' + batchId;
        fetch(updatebtchathlete, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setIsEdit(false);
                            setOpenModal(false);
                            fetchBatchAthletes();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function deleteBatchAthlete(btchAthleteId: string) {
        const deleteBatchAthlete = api.CenterBatchAthlete + '/' + btchAthleteId + '/' + 0;
        fetch(deleteBatchAthlete, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setOpenModal(false);
                            fetchBatchAthletes();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })

    }

    return (
        <>
            {isLoading && (

                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Batch Athletes</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newBatchAthlete() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Batch Athletes">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="centerBatchName"
                                                header="Batch Name"
                                                body={batchNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="athleteName"
                                                header="Athlete Name"
                                                body={athleteNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="centerBatchAthleteStatus"
                                                header="Batch Athlete Status"
                                                body={batchAthleteStatusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                openModal && (
                    <Modal
                        show={openModal}
                        size="xl"
                        centered>
                        <ModalHeader>
                            <ModalTitle>
                                <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Batch Athlete</h4>
                            </ModalTitle>
                            <Button
                                variant=""
                                className="btn-close"
                                onClick={() => setOpenModal(false)}
                            ></Button>
                        </ModalHeader>
                        <ModalBody>
                            <form ref={formRef}>
                                <div className="row">
                                    {/* <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">State Name</label>
                                            <Select
                                                value={stateList.find(state => state.geographyId === stateId) ? {
                                                    value: stateId,
                                                    label: stateList.find(state => state.geographyId === stateId).geographyName
                                                } : null}
                                                onChange={async (e) => {
                                                    setStateId(e.value);
                                                    const response = await func.listGeoDistrictByStateId(e.value);
                                                    setDistrictList(Array.isArray(response) ? response : [])
                                                }}
                                                required
                                                styles={customSelect}
                                                placeholder="Select State"
                                                options={stateList.map(state => ({
                                                    value: state.geographyId,
                                                    label: state.geographyName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">District Name</label>
                                            <Select
                                                value={districtList.find(dist => dist.geoDistrictsId === districtId) ? {
                                                    value: districtId,
                                                    label: districtList.find(dist => dist.geoDistrictsId === districtId).geoDistrictsName
                                                } : null}
                                                onChange={async (e) => {
                                                    setDistrictId(e.value);
                                                    const response = await func.listGeoCityByDistrictId(e.value);
                                                    setCityList(Array.isArray(response) ? response : [])
                                                }}
                                                required
                                                styles={customSelect}
                                                placeholder="Select District"
                                                options={districtList.map(dist => ({
                                                    value: dist.geoDistrictsId,
                                                    label: dist.geoDistrictsName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">City</label>
                                            <Select
                                                value={cityList.find(city => city.geoCityId === cityId) ? {
                                                    value: cityId,
                                                    label: cityList.find(city => city.geoCityId === cityId).geoCityName
                                                } : null}
                                                onChange={async (e) => {
                                                    setCityId(e.value);
                                                    const cntrResponse = await func.listGeoCentersByCityId(e?.value);
                                                    setCenterList(Array.isArray(cntrResponse) ? cntrResponse : [])
                                                }}
                                                required
                                                styles={customSelect}
                                                placeholder="Select City"
                                                options={cityList.map(city => ({
                                                    value: city.geoCityId,
                                                    label: city.geoCityName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div> */}
                                    <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Center</label>
                                            <Select
                                                value={centerList.find(center => center.geoCenterId === centerId) ? {
                                                    value: centerId,
                                                    label: centerList.find(center => center.geoCenterId === centerId).geoCenterName
                                                } : null}
                                                onChange={async (e) => {
                                                    setCenterId(e.value);
                                                    const batchResponse = await func.getUnassignedBatches(e.value);
                                                    setBatchList(Array.isArray(batchResponse) ? batchResponse : [])
                                                }}
                                                required
                                                styles={customSelect}
                                                placeholder="Select Center"
                                                options={centerList.map(center => ({
                                                    value: center.geoCenterId,
                                                    label: center.geoCenterName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Batch Name</label>
                                            <Select
                                                value={batchList.find(btch => btch.centerBatchId === batchId) ? {
                                                    value: batchId,
                                                    label: batchList.find(btch => btch.centerBatchId === batchId).centerBatchName
                                                } : null}
                                                onChange={async (e) => {
                                                    setBatchId(e.value);
                                                    setShowAthltLst(true)
                                                    const response = await func.listCenterActiveAthletes(centerId);
                                                    setAthleteList(Array.isArray(response) ? response : []);
                                                }}
                                                styles={customSelect}
                                                required
                                                placeholder="Select Batch"
                                                options={batchList.map(btch => ({
                                                    value: btch.centerBatchId,
                                                    label: btch.centerBatchName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div>
                                </div>
                                {showAthltLst ?
                                    <>
                                        <div className="court-information profile-availability">
                                            <div className="row accordion setting-accordion">
                                                <div className="token-slot mt-2" style={{ maxHeight: "400px", overflowY: "auto" }}>
                                                    {athleteList.map((athlt, index) => (
                                                        <div key={index} className="form-check-inline visits court-information col-12 col-sm-2 col-md-3">
                                                            <label className="visit-btns">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    defaultValue={athlt.userId}
                                                                    ref={el => addcheckboxRefs.current[index] = el}
                                                                />
                                                                <span
                                                                    className="visit-rsn"
                                                                    data-bs-toggle="tooltip"
                                                                    title={athlt.athleteName}
                                                                >
                                                                    {athlt.athleteName}
                                                                </span>
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </> : null
                                }
                                {/* {isEdit ?
                                    <>
                                        <div className="row">
                                            <div className="col-lg-12 mb-10">
                                                <div className="input-space">
                                                    <label className="form-label">Athlete Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="athletename"
                                                        disabled={isEdit}
                                                        required
                                                        value={batchAthleteName}
                                                        onChange={(e) => setBatchAthleteName(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <label className="form-label">Status</label>
                                            </div>
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                    <input
                                                        className="form-check-input text-end"
                                                        type="checkbox"
                                                        checked={batchAthleteStatus === '1'}
                                                        id="batchAthleteStatus"
                                                        onChange={(e) => {
                                                            setBatchAthleteStatus(e.target.checked ? '1' : '0')
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </> : null
                                } */}
                                <ModalFooter>
                                    <Button
                                        className="btn-primary text-uppercase"
                                        variant="success"
                                        type="submit"
                                        onClick={handleSubmit}
                                    >
                                        <b><i className="fas fa-save" />Save</b>
                                    </Button>
                                </ModalFooter>
                            </form>
                        </ModalBody>
                    </Modal >
                )
            }
        </>
    )
}

export default CenterBatchAthlete;